import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { FaPencilAlt } from 'react-icons/fa';
import FlexContainer from 'App/common/styles/FlexContainer';
import IconWrapper from 'App/common/styles/IconWrapper';
import EditMedicationModal from './EditMedicationModal';
import useGetReferralMedication from 'App/hooks/useGetReferralMedication';
import ReferralMedicationTable from './ReferralMedicationTable';

const propTypes = {
    patientId: PropTypes.string.isRequired,
    referralId: PropTypes.string.isRequired,
};

const defaultProps = {};

function ReferralMedication({ patientId, referralId }) {
    const { data = [], isLoading, refetch } = useGetReferralMedication(patientId, referralId);
    const [showEditModal, setShowEditModal] = useState(false);
    const handleUpdate = async () => {
        await refetch();
        setShowEditModal(false);
    };

    const onHide = () => {
        setShowEditModal(false);
    };

    return (
        <div className="referral-medication">
            <FlexContainer>
                <h3>Medications</h3>
                <div className="add-create-action">
                    <Button variant="link" onClick={() => setShowEditModal(true)}>
                        <IconWrapper>
                            <FaPencilAlt />
                        </IconWrapper>
                        Edit Medication
                    </Button>
                </div>
            </FlexContainer>

            <ReferralMedicationTable data={data} isLoading={isLoading} insideModal={false} />

            {showEditModal && (
                <EditMedicationModal
                    show={showEditModal}
                    onHide={onHide}
                    onUpdate={handleUpdate}
                    patientId={patientId}
                    referralId={referralId}
                />
            )}
        </div>
    );
}

ReferralMedication.propTypes = propTypes;
ReferralMedication.defaultProps = defaultProps;

export default ReferralMedication;
